import { Component } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { UserService } from 'src/app/services/user.service';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { versions } from 'src/environments/versions';
import { modifiedSetTimeout } from 'src/app/utilities/ZoneUtils';
import { filter } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'app-upgrade-version-notification',
  templateUrl: './upgrade-version-notification.component.html',
  styleUrls: ['./upgrade-version-notification.component.scss'],
})
export class UpgradeVersionNotificationComponent {
  public versions = versions;

  constructor(private readonly userService: UserService, private readonly swUpdate: SwUpdate) {
    this.swUpdate.checkForUpdate();
    this.swUpdate.versionUpdates
      .pipe(
        filter((event): event is VersionReadyEvent => event.type === 'VERSION_READY'),
        untilDestroyed(this),
      )
      .subscribe(() => {
        this.swUpdate.activateUpdate().then(() => {
          this.reload();
        });
      });

    modifiedSetTimeout(() => {
      this.reload();
    }, 60000);
  }

  reload(): void {
    this.userService.isUpdateButtonClicked.next(true);
    window.location.href = this.addQueryParamToUrl(window.location.href);
    window.location.reload();
  }

  addQueryParamToUrl(url: string) {
    const ulrArr = url.split('#');
    const urlQry = ulrArr[0].split('?');
    const usp = new URLSearchParams(urlQry[1] || '');
    usp.set('reload' || '_z', `${Date.now()}`);
    urlQry[1] = usp.toString();
    ulrArr[0] = urlQry.join('?');
    return ulrArr.join('#');
  }
}
